/*********************** Custom JS for Boost AI Search & Discovery  ************************/
boostSDAppConfig.analytics = {
	selectorAddToCart: '.boost-sd__btn-add-to-cart, #AddToCart'
}